import React from "react";
import { observer } from "mobx-react";
import { useEffect, useContext, useRef } from "react";
import { Fab, Box, Container, Alert } from "@mui/material";
import { Spinner } from "/@/app/components/Spinner";
import { ParameterView } from "/@/app/views/FreeMeasurementsView/ParameterView";
import { AppContext } from "/@/app/AppContext";
import { useApi} from '/@/app/Api';

import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';

import { ParameterState } from "/@/app/views/FreeMeasurementsView/ParameterState";
import { AddChangeParameter } from "/@/app/views/FreeMeasurementsView/AddChangeParameter";
import { actionDialogState } from "/@/app/views/FreeMeasurementsView/ActionDialog";


const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'absolute',
  bottom: 10, // Adjust this to control how much it floats above the BottomNavigation
  left: '50%',
  transform: 'translateX(-50%)',
}));


const BottomPanel = ({}) => {
    const api=useApi();
    const add = () => {
        actionDialogState.setComponent(AddChangeParameter, new ParameterState(null,api));
    }

    return (
        <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
            <Box position="relative">
                <StyledFab color="primary" aria-label="add" onClick={add}>
                    <AddIcon />
                </StyledFab>
            </Box>
        </Box>
    );
};


export const SectionView = observer(({ state }) => {
    const refs = useRef(new Map());
    const scrollRef = useContext(AppContext).mainViewportRef

    // scroll to new parameter
    useEffect(() => {
        if (state.recentNewParameter) {
            const element = refs.current.get(state.recentNewParameter.id);
            if (element) {
                const rect = element.getBoundingClientRect();
                scrollRef.current.scrollTo({
                    top: rect.top + scrollRef.current.scrollTop - 90, // XXX header height magic number
                    behavior: "smooth"
                });
            }
        }
    }, [state.recentNewParameter]);


    if (state.visibleParameters === null) {
        return (
            <Container sx={{ mt: 4, textAlign: "center" }}>
                <Spinner size={60} />
            </Container>
        );
    }
    if (state.visibleParameters.length === 0) {
        return (
            <>
                <Container sx={{ mt: 4, textAlign: "center" }}>
                    <Alert severity="info">В этом разделе пока нет параметров.</Alert>
                </Container>
                <BottomPanel />
            </>
        );
    }

    return (
        <>
            <Alert severity='warning' sx={{ mb: 4 }}>
                Личные замеры - Альфа-версия.
                <br />
                Здесь вы можете добавлять измерения вне панелей, и создавать собственные параметры.
            </Alert>

            {state.visibleParameters.map((item) => (
                // box is just a scroll target
                <Box
                    key={item.id}
                    ref={el => refs.current.set(item.id, el)}
                >
                    <ParameterView
                        key={item.id}
                        state={item}
                    />
                </Box>
            ))}
            <BottomPanel />
        </>
    );
});

